import i18n from 'i18next';

// Compact "time since" label ("just now" / "5 min ago" / "3 hr ago" / "2d
// ago"). Strings live in the `common` namespace (bootstrapped, so no lazy
// suspense from this non-component util) and use i18next count-plurals, so
// es-MX renders "hace 2 días" with correct singular/plural. Reads
// i18n.language at call time — same pattern as timeWindow.ts.
export function formatRelativeTime(iso: string): string {
  const diffSec = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  const t = (key: string, count?: number): string =>
    i18n.t(key, { ns: 'common', ...(count === undefined ? {} : { count }) });

  if (diffSec < 60) return t('relativeTime.justNow');
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return t('relativeTime.minAgo', diffMin);
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return t('relativeTime.hrAgo', diffHr);
  const diffDay = Math.floor(diffHr / 24);
  return t('relativeTime.dayAgo', diffDay);
}
